export const SystemTheme = 'system' as const;
export const SimpleThemeNames = ['dark', 'light'] as const;
export const ThemeNames = [...SimpleThemeNames, SystemTheme] as const;

export type SimpleThemeName = (typeof SimpleThemeNames)[number];
export type ThemeName = (typeof ThemeNames)[number];
